import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nProvider";
import HomeTurista from "@/pages/HomeTurista";
import HomePartner from "@/pages/HomePartner";
import Privacy from "@/pages/Privacy";
import AdminLogin, { RequireAdmin } from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ThemeManager from "@/components/itly/ThemeManager";
import LogoIntro from "@/components/itly/LogoIntro";
import InteractiveFx from "@/components/itly/InteractiveFx";
import SiteBackdrop from "@/components/itly/SiteBackdrop";

function App() {
    return (
        <div className="App">
            <I18nProvider>
                <BrowserRouter>
                    <ThemeManager />
                    <SiteBackdrop />
                    <LogoIntro />
                    <InteractiveFx />
                    <Routes>
                        <Route path="/" element={<HomeTurista />} />
                        <Route path="/partner" element={<HomePartner />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
                    </Routes>
                </BrowserRouter>
            </I18nProvider>
        </div>
    );
}

export default App;
